import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RenovateContractPymes } from '../../models/renovate-contract-pymes.model';
import { AuthService } from 'src/app/auth';

@Component({
  selector: 'app-renovate-contract-pymes-resume',
  templateUrl: './renovate-contract-pymes-resume.component.html',
  styleUrls: ['./renovate-contract-pymes-resume.component.scss']
})
export class RenovateContractPymesResumeComponent implements OnInit {
  public tabCampaign = false;
  public tabSocialReason = false;
  public tabInstallation = false;
  public tabPayment = false;
  public isUserSpanish = true;

  constructor(
    private dialogRef: MatDialogRef<RenovateContractPymesResumeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RenovateContractPymes,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    this.isUserSpanish = this.auth.getUserData().country === 'ES';
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public handleTabCampaign(): void {
    this.tabCampaign = !this.tabCampaign;
  }

  public handleTabSocialReason(): void {
    this.tabSocialReason = !this.tabSocialReason;
  }

  public handleTabInstallation(): void {
    this.tabInstallation = !this.tabInstallation;
  }

  public handleTabPayment(): void {
    this.tabPayment = !this.tabPayment;
  }
}
